export default __webpack_public_path__ + "static/media/twitter.2a867539.jpg";